// @ts-nocheck
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetAbsenceAttendanceType, cleanAbsenceAttendanceTypeList } from '../../store/HR/Person/absenceSlice';

const useAbsenceType = personId => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(GetAbsenceAttendanceType(personId));

    return () => {
      dispatch(cleanAbsenceAttendanceTypeList());
    };
  }, [personId]);

  const { AbsenceAttendanceTypeList, loading3: loading, error3: error } = useSelector(state => state.Absence);

  return { AbsenceAttendanceTypeList, loading, error };
};

export default useAbsenceType;
